import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React, { useRef } from 'react';

import { SuppliersTable } from 'components/SuppliersTable';
import { HideStationSelector } from 'layouts/HideStationSelector';

export function Suppliers() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <HideStationSelector>
      <TablePageLayout
        title="Leveranciers"
        actionContent={
          <Button
            sx={{ ml: 5 }}
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              tableRef.current?.openFormDialog();
            }}
          >
            Leverancier toevoegen
          </Button>
        }
      >
        <SuppliersTable
          id="suppliers-table"
          ref={tableRef}
          searchFilter={{
            inputProps: {
              placeholder: 'Zoeken op naam of andere leveranciersvelden',
            },
            filter: (search) => ({
              _or: search.flatMap((str) => [
                { firstName: { _ilike: `%${str}%` } },
                { lastName: { _ilike: `%${str}%` } },
                { phone: { _ilike: `%${str}%` } },
                { email: { _ilike: `%${str}%` } },
              ]),
            }),
          }}
        />
      </TablePageLayout>
    </HideStationSelector>
  );
}
